import React from 'react'
import Link from 'next/link'
import { Button } from 'antd'
import styles from './ActionButtonLink.module.scss'

interface ActionButtonLinkProps {
  link: string
  text: string
  icon: React.ReactNode
}

const ActionButtonLink: React.FC<ActionButtonLinkProps> = (props) => {
  const { link, text, icon } = props

  return (
    <Link href={link} passHref>
      <Button
        block
        className={styles['action-button']}
        icon={icon}
      >
        {text}
      </Button>
    </Link>
  )
}

export default ActionButtonLink
